import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Rocket, ArrowRight } from 'lucide-react';
import axiosInstance from '../../api/axios';

export const LaunchChecklistBanner = () => {
  const [data, setData] = useState(null);
  useEffect(() => {
    axiosInstance.get('/admin/launch-checklist').then((r) => setData(r.data)).catch(() => {});
  }, []);
  if (!data || data.done_count === data.total) return null;
  return (
    <Link
      to="/admin/launch-checklist"
      className="mb-5 flex items-center justify-between gap-3 p-3 border border-[#C4A484] bg-[#FAF5EE] hover:bg-[#F3EADF] transition-colors"
      data-testid="launch-checklist-banner"
    >
      <span className="flex items-center gap-2 text-sm text-[#5D4E3C]">
        <Rocket className="h-4 w-4 text-[#8B7355]" />
        <strong>Start-Checkliste:</strong> {data.done_count} von {data.total} erledigt
      </span>
      <ArrowRight className="h-4 w-4 text-[#8B7355]" />
    </Link>
  );
};
